import { Injectable, Signal, computed, signal } from '@angular/core';
import { DashboardFrameConfig, EMPTY_DASHBOARD_FRAME_CONFIG } from './dashboard-frame-config';


@Injectable({ providedIn: 'root' })
export class DashboardFrameService {

	private _config = signal<Signal<DashboardFrameConfig>>(signal(EMPTY_DASHBOARD_FRAME_CONFIG));


	public config = computed(() => {
		const _config = this._config();
		return _config();
	});


	public initialize(config: Signal<DashboardFrameConfig>) {
		this._config.set(config);
	}
}